<!-- 设备监控 -->
<template>
    <div class='container containerBox tc-box'>
        <!-- <router-link to="/terminalcontrollist/terminalcontrolset">设置设备监控</router-link> -->
        <div class="tc-header">
            <span class="menu-title">监控列表：</span>
            <div class="menu-list-box clear">
                <ul class="menu-list" id="menu-list">
                    <template v-for="(v, i) in list">
                        <li class="menu-list-item" :key="v.OID">
                            <el-dropdown size="small" @click="handleClickTc(v, i)" split-button trigger="click" :type="active === i ? 'primary': ''">
                                {{v.map_name}}
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item @click.native="handleEdit(v)"><i class="el-icon-edit"></i></el-dropdown-item>
                                    <el-dropdown-item @click.native="handleDelete(v)"><i class="el-icon-delete"></i></el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </li>
                    </template>
                </ul>
            </div>
            <el-button type="primary" class="add-btn" @click="handleAdd" size="small" icon="el-icon-plus">添加设备监控</el-button>
        </div>
        
        <!-- 平面列表 -->
        <!-- <div class="tc-left">
            <p class="nodeinfo-title">平面监控列表</p>
            <ul class="tc-list">
                <template v-for="(v, i) in list">
                    <li :class="active === i ? 'tc-item active': 'tc-item'" @click="handleClickTc(v, i)" :key="v.OID">
                        <span>{{v.Map_name}}</span>
                        <span class="tc-item-opt">
                            <i class="el-icon-edit" @click="handleEdit(v)"></i>
                            <i class="el-icon-delete" @click="handleDelete(v)"></i>
                        </span>
                    </li>
                </template>
            </ul>
            <p style="text-align:center;margin:20px 0;"><el-button type="primary" @click="handleAdd" icon="el-icon-plus">添加设备监控</el-button></p>
        </div> -->
        <div class="tc-right">
            <!-- 状态 + 控制 -->
            <p class="nodeinfo-title">当前设备信息</p>
            <p class="nodeinfo-item">
                <span>序列号：：</span>
                <span class="TerminalSerial"></span>
            </p>
            <p class="nodeinfo-item">
                <span>设备类型：</span>
                <span class="DevType"></span>
            </p>
            <p class="nodeinfo-item">
                <span>位置：</span>
                <span class="HouseName"></span>
            </p>
            <p class="nodeinfo-item">
                <span>所属集控器：</span>
                <span class="CollectorSerial"></span>
            </p>
            <p class="nodeinfo-title">控制全部设备
                <el-tooltip class="item" effect="dark" content="控制该场景下面的全部设备！" placement="right-start">
                    <i class="el-icon-info" style="font-size:12px;vertical-align: text-top;margin: 0 0 0 5px;"></i>
                </el-tooltip>
            </p>
            <el-form :model="formAll" status-icon :rules="rules" ref="AllForm" style="margin:0 10px;" label-width="80px" class="ruleForm">
                <el-form-item label="状态" prop="power_on">
                    <el-select v-model="formAll.powerStatus" clearable placeholder="请选择">
                        <el-option
                              v-for="item in options1"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="风速" prop="speed">
                    <el-select v-model="formAll.fanSpeed" clearable placeholder="请选择">
                        <el-option
                              v-for="item in options2"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="模式" prop="mode">
                    <el-select v-model="formAll.workMode" clearable placeholder="请选择">
                        <el-option
                              v-for="item in options3"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="温度设置" prop="roomTemperatureSp">
                    <el-input v-model="formAll.roomTemperatureSp" 
                        @blur="handleChangeAllInput('roomTemperatureSp')" 
                        clear 
                        placeholder="请输入温度"></el-input>
                </el-form-item>
                <el-form-item label="锁定" prop="key_lock">
                    <el-select v-model="formAll.keyBoardlock" clearable placeholder="请选择">
                        <el-option
                              v-for="item in options4"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" style="width:100%;" :disabled="list.length===0" @click="onSubmitAll">确认</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="tc-content"  id="topology-body">
            <canvas class="topology-context" id="topology-canvas"></canvas>
            <!-- 加载提示框 -->
            <div class="tip-loading" v-loading="loading" element-loading-spinner="el-icon-loading">
                
            </div>
            <!-- 提示框 -->
            <div class="tip-opt">
                <el-tooltip class="item" effect="dark" placement="left">
                    <div slot="content" style="line-height: 20px;">
                        <p>1、滚动鼠标滚轮可以放大缩小场景图</p>
                        <p>2、按住ctrl或者空格键可以拖动场景图</p>
                        <p>3、鼠标右击设备图标可以控制设备</p>
                        <p>4、双击设备图标可以查看设备更多信息</p>
                    </div>
                    <i class="el-icon-question"></i>
                </el-tooltip>
            </div>
            <!-- 操作工具栏 -->
            <div class="tip-menu">
                <!-- <i class="el-icon-rank" @click="handleFull">居中</i> -->
                <i class="el-icon-rank" @click="handleFull">全屏</i>
            </div>
            <!-- 鼠标悬浮显示节点信息 -->
            <div class="node-infobox" id="node_infobox" style="display:none;">
                <span>序列号：<label name="node_TerminalSerial"></label></span>
				<span>设备型号：<label name="node_TerminalModel"></label></span>
                <span style="display: none;">类型：<label name="current_Type"></label></span>
                <span>安装位置：<label name="current_HouseName"></label></span>
                <span>状态：<label name="current_poweron"></label></span>
                <span>风速：<label name="current_speed"></label></span>
                <span>电磁阀：<label name="current_valveon"></label></span>
                <span>模式：<label name="current_mode"></label></span>
                <span>设置温度：<label name="current_temperature"></label></span>
                <span>室内温度：<label name="current_room_temperature"></label></span>
            </div>

            <!-- 右击节点菜单 -->
            <div class="tc-menu" id="tc_node-menu">
                <div @click="handleControlDE">
                    <span>控制设备</span>
                </div>
            </div>

            <!-- 控制设备弹框 -->
            <el-dialog
                title="控制设备"
                :visible.sync="dialogVisible"
                width="30%"
                :before-close="handleClose">
                <el-form :model="form" status-icon :rules="rules" ref="ruleForm2" label-width="90px" class="ruleForm">
                    <el-form-item label="状态" prop="power_on">
                        <el-select v-model="form.powerStatus" :popper-append-to-body="false" clearable placeholder="请选择">
                            <el-option
                                  v-for="item in options1"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="showspeed" label="风速" prop="speed">
                        <el-select v-model="form.fanSpeed" :popper-append-to-body="false" clearable placeholder="请选择">
                            <el-option
                                  v-for="item in options2"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="模式" prop="mode">
                        <el-select v-model="form.workMode" :popper-append-to-body="false" clearable placeholder="请选择">
                            <el-option
                                  v-for="item in options3"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="温度设置" prop="temperature">
                        <el-input v-model="form.roomTemperatureSp" 
                            @blur="handleChangeInput('roomTemperatureSp')" 
                            clear 
                            placeholder="请输入温度">
                            <span slot="suffix">℃</span>
                            </el-input>
                    </el-form-item>
                    <el-form-item label="锁定" prop="key_lock">
                        <el-select v-if="showmut == true" v-model="form.keyBoardlock" :popper-append-to-body="false" clearable placeholder="请选择">
                            <el-option
                                  v-for="item in options4"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                            </el-option>
                        </el-select>
						<el-select v-if="showmut == false" v-model="locks" :popper-append-to-body="false" multiple placeholder="请选择" @change="changlock">
						    <el-option
						          v-for="item in options4"
						          :key="item.value"
						          :label="item.label"
						          :value="item.value">
						    </el-option>
						</el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">确认</el-button>
                        <el-button @click="onClose">取消</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex"; 
import bus from "@/utils/bus";
import Service from '@/api/Service'
import {$Alert} from '@/utils/utils'
import { CLUSTERMANA } from '@/api/configData.js'
import List_Editor from './jtopo-TCL.js'
import { fmtMeterInfo, fmtData } from './fmtMeterInfo'

let timer = null
export default {
    name:  'terminalcontrollist',
    inject: ["reload"],
    data() {
      return {
            list: [],
            active: 0,
			showmut:true,
			showspeed:true,
            nodeIds: [],

            dialogVisible:false,
            terminalid: '',
            controlType: 1,
         //  控制参数设置
            form: {
                powerStatus: '',             //  开关机：1
                fanSpeed: '',            //  风速：0
                workMode: '',         //  模式：0
                roomTemperatureSp: '',        //  设置温度：0
                keyBoardlock: '',          //  按键锁：0
            }, 
			locks:[],
			terminallist:[],
            // 参数设置校验
            rules: {},
            configData: CLUSTERMANA,
            meterInfo: {},

            formAll: {
                powerStatus: '',             //  开关机：1
                fanSpeed: '',            //  风速：0
                workMode: '',         //  模式：0
                roomTemperatureSp: '',        //  设置温度：0
                keyBoardlock: '',          //  按键锁：0
            },
			options1: [{
			          value: 'on',
			          label: '开机'
			        }, {
			          value: 'off',
			          label: '关机'
			        }],
			options2: [{
			          value: 'auto',
			          label: '自动'
			        }, {
			          value: 'high',
			          label: '高风'
			        }, {
			          value: 'medium',
			          label: '中风'
			        }, {
			          value: 'low',
			          label: '低风'
			        }],
			options3: [{
			          value: 'cool',
			          label: '制冷'
			        }, {
			          value: 'fan',
			          label: '通风'
			        }, {
			          value: 'heat',
			          label: '制热'
			        }, {
			          value: 'auto',
			          label: '自动'
			        }],
			options4: [
					{
					  value: 0,
					  label: '解除锁定'
					},{
			          value: 1,
			          label: '锁定开关机',
			        }, {
			          value: 2,
			          label: '锁定模式',
			        }, {
			          value: 4,
			          label: '锁定风速',
			        }, {
			          value: 8,
			          label: '锁定温度',
			        }, {
			          value: 15,
			          label: '锁定全部'
			        }],	
            loading: false,
      };
    },
    computed: {
        ...mapGetters(["WS", "ws_terminalReading", "user", "projectsystemInfo","ws_notice"]),
    },
    watch: {
        // 监听socket数据
        ws_terminalReading: {
            handler(newVal,oldVal){
                //code...业务逻辑
                this.loading = true;
                this.fmtWsMeter(newVal)
            },
            immidiate:true,
            deep:true,
        },
		ws_notice:{
			handler(newVal,oldVal){
				//code...业务逻辑
				this.loading = true;
				this.addnewWarning(newVal)
				console.log(newVal)
			},
		}
    },
    mounted() {
        this.$nextTick(()=>{
            this.getTcsData();
        })
        
    },
    created() {
        // 通过 Event Bus 进行组件间通信，来折叠侧边栏
        bus.$on("collapse", msg => {
            window.clearTimeout(timer)
            timer = window.setTimeout(() => {
                let canvas = document.getElementById('topology-canvas')
                if(canvas) {
                    canvas.width = $('#topology-body').width();
                    canvas.height = $('#topology-body').height();
                }
            }, 1000);
        });
    },
    destroyed() {
        // 关闭设备监控
        this.wsSendData("21", "[]");
    },
    methods: {
		changlock(val){
			this.form.keyBoardlock = null
			for(var i = 0 ; i<val.length;i++){
				if(val[i] == 0){
					this.locks = [0]
					
				}
				if(val[i] == 15){
					this.locks = [15]
				}
				this.form.keyBoardlock = this.form.keyBoardlock + val[i]
			}
		},
        // 温度输入框
        handleChangeInput(key, val) {
            let value = this.form[key];

            if(isNaN(value) || value<10 || value>50) {
                this.$message({
                    type: "warn",
                    message: "温度可设置范围10-50;"
                })
                this.form[key] = "";
            }
        },
        // 温度输入框
        handleChangeAllInput(key, val) {
            let value = this.formAll[key];

            if(isNaN(value) || value<10 || value>50) {
                this.$message({
                    type: "warn",
                    message: "温度可设置范围10-50;"
                })
                this.formAll[key] = "";
            }
        },
        // 发送websocket
        wsSendData(type, ids){
            let userid = this.user.oid + "";
            let assigned_project_id = this.projectsystemInfo.oid + "";
            let sendtype = type;
            let monitortidlist = ids;
            if(this.WS && this.WS.$alive) {
                this.WS.send(JSON.stringify({userid, assigned_project_id, sendtype, monitortidlist}))
            }
        },
        setMenuWidth() {
            this.$nextTick(()=>{
                let box = document.getElementById("menu-list");
                let lis = box.getElementsByClassName("menu-list-item");
                let width = 0;
                for(let i=0; i<lis.length; i++) {
                    width += lis[i].offsetWidth + 12;
                }
                box.style.width = width + "px";
            })
        },
        async getTcsData() {
            let data = await Service.getEmcsList()
            data = data === 'success' ? [] : data;
            if(data.length){
                this.list = this.fmtEmcsList(data);
                this.setMenuWidth();
                // 绘图
                List_Editor.init('', '', this.list[0].jtopo_data, '');
                // 获取表计读数
                this.getDevicesList(this.list[0].terminal_oid);
            }else{
                let canvas = document.getElementById('topology-canvas')
                    canvas.width = $('#topology-body').width();
                    canvas.height = $('#topology-body').height();
                    let stage = new JTopo.Stage(canvas)         // 定义舞台对象
                    let scene = new JTopo.Scene(stage)    // 定义场景对象
                    var node = new JTopo.TextNode("暂无设备监控场景，请前往添加！");    // 创建一个节点
                    node.font = "14px 微软雅黑";
                    node.fontColor = "102,102,102";
                    node.setLocation(0,0);    // 设置节点坐标                    
                    scene.add(node); // 放入到场景中
                    stage.centerAndZoom();
            }
        },
        fmtEmcsList(list) {
            let nodeIds = [];
            list.map(v=>{
                let arr = [];
                v.jtopo_data = JSON.parse(v.map_value);
                let childs = v.jtopo_data;
                if(childs && childs.childs && childs.childs[0].childs) {
                    childs.childs[0].childs.map(v2=>{
                        let obj = {}
                        if(v2.nodeType === 'BG') {
                            v2.showSelected = false;    // 选中不显示选框
                        }
                        if(v2.nodeType === 'DE'){
                            let nodeMeterInfo = v2.nodeParams.nodeMeterInfo.split('$')
                            obj.type = nodeMeterInfo[3];
                            obj.oid = v2.nodeParams.nodeOID;
                            obj.nodeId = v2.nodeId;
							obj.zIndex ='666';
                            arr.push(obj)
                        }
						
                        v2.dragable = false;    //  不允许拖动
                    })
                    
                }
                nodeIds.push(arr);
            })
            this.nodeIds = nodeIds
            return list
        },
        // 获取当前选择平面的表计实时状态
        async getDevicesList(ids) {
            if(ids === '[]') return
            let list = await Service.getOIDSTerminalreadings({oidlist: ids});
            if(list) {
                list = list === 'success' ? [] : list;
                // 过滤不存在设备ID
                let ErrorMeterIds = list.filter(v=>{ return v.ErrorTerminalID && v.ErrorTerminalID>0 })
                let SuccessMeterIds = list.filter(v=>{ return !v.ErrorTerminalID })
                
                let allMeterInfo = fmtData(SuccessMeterIds);
				
                this.meterInfo = allMeterInfo;
                let warningOid = this.fmtMeterOID(allMeterInfo);    //  报警OID
                this.addWarning(warningOid);
                this.addError(ErrorMeterIds);
                List_Editor.meterInfo = fmtMeterInfo(allMeterInfo);
            }
            this.wsSendData("20", ids);
        },
        // 控制选中设备
        handleControlDE() {
            let node = List_Editor.utils.getSelectedNodes();
			// console.log(node)
            if(node.length === 1) {
                let DevType = node[0].nodeParams.nodeMeterInfo.split('$')[3];
                this.terminalid = node[0].nodeParams.nodeOID;
                this.controlType = DevType
            };
            this.dialogVisible = true;
			let type = this.terminallist.find(val =>{
				return val.terminalid == this.terminalid
			})
			if(type["device-model"] == "FC226W"){
				this.showmut =false
			}else{
				this.showmut =true
			}
			if(type["device-model"] == "FC900C"){
				this.showspeed =false
			}else{
				this.showspeed =true
			}
			
        },
        onClose() {
            this.$refs['ruleForm2'].resetFields();
            this.dialogVisible = false;
            this.$nextTick(()=>{
                $('#tc_node-menu').hide();
                $('#node_infobox').fadeOut();
            })
        },
        handleClose(done) {
            this.$refs['ruleForm2'].resetFields();
            done();
            // 隐藏菜单栏
            this.$nextTick(()=>{
                $('#tc_node-menu').hide();
                $('#node_infobox').hide();
            })
        },
        // 控制单个表计
        async onSubmit() {
            let form = Object.assign({},this.form);
            form.terminalid = this.terminalid
            form.devtype = this.controlType;
            this.dialogVisible = false;
            let data = await Service.controlmorebytid(form);
            if(data) {
                this.$notify({
                    title: '发送成功',
                    message: '操作指令已下发，由于设备实时状态上报有延迟，请等待页面实时数据刷新。',
                    type: 'success'
                });

                this.dialogVisible = false;
            }
        },
        // 控制全部表计
        async onSubmitAll() {
            let active = this.active;
            let ids = this.list[active].terminal_oid;
            
            let form =  Object.assign({},this.formAll);
            
            let params = Object.assign({}, form, {tidlist: ids})

            let data = await Service.controlmorebytidlist(params);
            if(data) {
                this.$notify({
                    title: '发送成功',
                    message: '操作指令已下发，由于设备实时状态上报有延迟，请等待页面实时数据刷新。',
                    type: 'success'
                });
            }
        },
        // 选择平面监控
        handleClickTc(v,i){
            if(this.active === i) return;
            this.active = i;
            // 重置监控板
            List_Editor.resetTopology(v.jtopo_data);
            this.getDevicesList(v.terminal_oid);
        },
        handleDelete(v) {
            $Alert(`确认删除${v.map_name}, 是否继续?`).then( async (bool)=>{
                if(bool){
                    let data = await Service.delEmcs({oid:v.oid});
                    if(data) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!',
                            duration: 1500,
                        });
                        this.reload();
                    }
                }   
            });
        },
        handleEdit(v){
            this.$router.push('/terminalcontrollist/terminalcontrolset/'+ v.oid)
        },
        // 增加平面监控
        handleAdd() {
            this.$router.push('/terminalcontrollist/terminalcontrolset/0');
        },
        // 筛选报警OID
        fmtMeterOID(list) {
            let oids = []
            if(!list || list.length<=0) {
                // 全部故障
                let active = this.active
                this.nodeIds[active].map(v=>{
                    oids.push({
                        devType: v.type,
                        oid: v.oid,
                        type: '设备故障',
                        icon: 'warn'
                    })
                    return
                })
            }else{
                list.map(v=>{
                    // if(JSON.stringify(v._data) === "{}") {
					if(v.status === 2) {
                        oids.push({
                            devType: v.type,
                            oid: v.terminalid,
                            type: '设备离线',
                            icon: 'warn',
                        })
                        return
                    }
                    if(v.power_on == 0){
                        oids.push({
                            devType: v.type,
                            oid: v.terminalid,
                            type: '设备关机',
                            icon: 'off',
                        })
                        return
                    }
                    oids.push({
                        devType: v.type,
                        oid: v.terminalid,
                        type: '设备正常',
                        icon: 'normal',
                    })
                })
            }
            return oids
        },
		
        // 增加报警
        addWarning(oids) {
            let active = this.active
            if(!oids.length) return;
            oids.map(v=>{
                let node = this.nodeIds[active].filter(n=>{
                    return n.oid == v.oid
                })
                if(node.length>0) {
                    node.map(n=>{
                        let t_Node = List_Editor.utils.getNodeByKey('nodeId', n.nodeId);
                        t_Node.alarm = "";
                        if(v.devType == 1) {
                            t_Node.setImage('/static/images/' + 'img-wkq-' + v.icon + '.png');
                        }else {
                            t_Node.setImage('/static/images/' + 'img-fg-' + v.icon + '.png');
                        }
                    })
                }
            })
        },
		// 增加报警type1
		addnewWarning(arr) {
			let active = this.active
			var devType=0
			if(!arr.length) return;
			arr.map(v=>{
				if(v.dev_type == "terminal" && v.key == "online_status" && v.status==1){
					if(v["model"] == 'FC890' || v["model"] == 'FC900C'){
						devType = 2;
					}else{
						devType = 1;
					}
				}else{
					return
				}
				let node = this.nodeIds[active].filter(n=>{
					return n.oid == v.id
				})
				if(node.length>0) {
					node.map(n=>{
						let t_Node = List_Editor.utils.getNodeByKey('nodeId', n.nodeId);
						t_Node.alarm = "";
						if(devType == 1) {
							t_Node.setImage('/static/images/img-wkq-warn.png');
						}else {
							t_Node.setImage('/static/images/img-fg-warn.png');
						}
					})
				}
			})
		},
        // 增加设备不存在提示
        addError(oids) {
            let active = this.active
            if(!oids.length) return;
            oids.map(v=>{
                let node = this.nodeIds[active].filter(n=>{
                    return n.oid == v.ErrorTerminalID
                })
                if(node.length>0) {
                    let t_Node = List_Editor.utils.getNodeByKey('nodeId', node[0].nodeId);
                    t_Node.alarm = "设备不存在"
                    t_Node.fontColor = "255,255,255"
                }
            })
        },
        fmtWsMeter(newVal) {
            let list = newVal;
            let newArr = list.map(v=>{
                let obj = {}
                    // obj.terminalid = v.terminal.OID;
                    // obj["device-model"] = v.terminal.DevModule;
                    // obj["device-serial"] = v.terminal.TerminalSerial;
                    // obj["status"] = v.terminal.OnlineStatus;
                    // obj["householdname"] = v.terminal.HouseHoldName;
                    // obj["housename"] = v.terminal.HouseName;
					obj.terminalid = v.terminal_id;
					obj["device-model"] = v.terminal["device-model"];
					obj["device-serial"] = v.terminal["device-serial"];
                if(v.terminal) {
					obj.data=v.terminal.data
                }else {
                    obj.data = {}
                }
                return obj
            })
            // console.log("newArr", newArr);
			this.terminallist = newArr
            let allMeterInfo = fmtData(newArr);
            this.meterInfo = allMeterInfo;

            let warningOid = this.fmtMeterOID(allMeterInfo);    //  报警OID
            this.addWarning(warningOid);

            List_Editor.meterInfo = fmtMeterInfo(allMeterInfo);
            setTimeout(() => {
                this.loading = false;
            }, 1000);
        },
        // 全屏查看
        handleFull() {
            let element = document.getElementById("topology-body");
            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    // IE11
                    element.msRequestFullscreen();
                }
            }
            this.fullscreen = !this.fullscreen;
            
            // 机房监控页面
            setTimeout(() => {
                let canvas = document.getElementById('topology-canvas')
                if(canvas) {
                    canvas.width = $('#topology-body').width();
                    canvas.height = $('#topology-body').height();
                    Machine_Editor.utils.showInCenter()
                }
            }, 1000);
        },
    }
}

</script>

<style lang='less' scoped>
    .tc-box{
        height: calc(100% - 60px);
        padding: 0;
        position: relative;
        .nodeinfo-title{
            height: 42px;
            line-height: 42px;
            color: #333;
            background-color: #f2f2f2;
            font-size: 16px;
            font-weight: 400;
            margin-bottom: 20px;
            text-align: center;
        }
        .tc-header{
            z-index: 99;
            position: relative;
            width: 100%;
            min-height: 42px;
            box-shadow: 0 5px 10px #ddd;
            .menu-title{
                position: absolute;
                left: 15px;
                top: 5px;
                line-height: 32px;
            }
            .menu-list-box{
                overflow-x: auto;
                overflow-y: hidden;
                margin: 0 145px 0 100px;
                &::-webkit-scrollbar {
                    // width: 2px;
                    height: 4px;
                }
                &::-webkit-scrollbar-track {
                    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
                    border-radius: 0;
                    background: rgba(0,0,0,0.1);
                }
                &::-webkit-scrollbar-thumb {
                    border-radius: 10px;
                    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
                    background: rgba(0,0,0,0.2);
                }
                .menu-list{
                    min-width: 100%;
                    li{
                        display: inline-block;
                        vertical-align: middle;
                        border-radius: 3px;
                        margin: 5px;
                        box-sizing: border-box;
                    }
                }
            }
            .add-btn{
                position: absolute;
                right: 5px;
                top: 5px;
                z-index: 100;
            }
        }
        // .tc-left{
        //     float: left;
        //     width: 300px;
        //     height: 100%;
        //     .tc-list{
        //         text-align: left;
        //         margin: 0 10px;
        //         .tc-item{
        //             padding-left: 15px;
        //             font-size: 14px;
        //             cursor: pointer;
        //             line-height: 44px;
        //             height: 44px;
        //             border-bottom: 1px solid #ccc;
        //             position: relative;
        //             // &:nth-child(2n){
        //             //     background-color: #f5f7fa;
        //             // }
        //             &.active{
        //                 color: @primary-color;
        //                 background-color: #f5f7fa;
        //             }
        //             &:hover{
        //                 color: @primary-color;
        //                 background-color: #f5f7fa;
        //                 .tc-item-opt{
        //                     display: block;
        //                 }
        //             }
        //             .tc-item-opt{
        //                 display: none;
        //                 position: absolute;
        //                 right: 10px;
        //                 top: 0;
        //                 line-height: 44px;
        //                 height: 44px;
        //                 z-index: 99;
        //                 i{
        //                     margin-left: 8px;
        //                 }
        //             }
        //         }
        //     }
        // }
        .tc-right{
            float: right;
            width: 300px;
            height: 100%;
            overflow-y: auto;
            .nodeinfo-item{
                // display: none;
                font-size: 14px;
                color: #666;
                margin:0 20px;
                margin-bottom: 10px;
                span{
                    line-height: 30px;
                }
            }
        }
        .tc-content{
            position: relative;
            margin:0 300px 0 0;
            height: 100%;
            padding: 10px;
            background-color: rgb(226, 229, 236);
            .tip-opt{
                position: absolute;
                right: 20px;
                top: 20px;
                font-size: 16px;
                z-index: 999;
            }
            .tip-menu{
                position: absolute;
                right: 60px;
                top: 20px;
                font-size: 16px;
                z-index: 999;
                cursor: pointer;
            }
            .tip-loading{
                position: absolute;
                left: 20px;
                top: 30px;
                width: 20px;
                height: 20px;
                z-index: 999;
            }
        }
    }
    .tc-menu{
        display: none;
        width: 130px;
        font-size: 12px;
        border: 1px solid rgb(84, 92, 100);
        position: absolute;
        padding: 6px;
        color: rgb(255, 255, 255);
        background-color: rgb(84, 92, 100);
        border-radius: 3px;
        &:hover{
            background-color: rgb(67, 74, 80);
        }
        span{
            display: block;
            cursor: pointer;
            &:hover{
                color: @primary-color;
            }
        }
    }
/* 	/deep/ .el-icon-edit{
		display: block;
		font-size: 20px;
	} */
</style>